module.exports = __webpack_public_path__ + "fonts/F37Moon-RegularIt.0a30026.otf";